export const BUILDERS_SHARE_PROGRESS_TITLE_STEP0 = '公開';
export const BUILDERS_SHARE_PROGRESS_TITLE_STEP1 = 'STEP 1';
export const BUILDERS_SHARE_PROGRESS_TITLE_STEP2 = 'STEP 2';
export const BUILDERS_SHARE_PROGRESS_TITLE_STEP3 = 'STEP 3';
